
import Vue from 'vue'
import { ContestWinner } from '@/model/ContestWinner'
import ContestWinnersPlaces from '@/components/contest/ContestWinnersPlaces.vue'

export default Vue.extend({
  name: 'ContestWinnersGroup',
  components: {
    ContestWinnersPlaces,
  },
  props: {
    winnersGroup: {
      type: Array,
    },
  },
  computed: {
    firstPlaces: function (): ContestWinner[] {
      return this.winnersGroup.filter(
        (element) => (element as ContestWinner).place === 1
      ) as ContestWinner[]
    },
    secondPlaces: function (): ContestWinner[] {
      return this.winnersGroup.filter(
        (element) => (element as ContestWinner).place === 2
      ) as ContestWinner[]
    },
    thirdPlaces: function (): ContestWinner[] {
      return this.winnersGroup.filter(
        (element) => (element as ContestWinner).place === 3
      ) as ContestWinner[]
    },
    optionalAwardPlaces: function (): ContestWinner[] {
      return this.winnersGroup.filter(
        (element) => (element as ContestWinner).place === 999
      ) as ContestWinner[]
    },
    nextPlaces: function (): ContestWinner[] {
      return this.winnersGroup.filter(
        (element) => ((element as ContestWinner).place > 3) && ((element as ContestWinner).place < 999)
      ) as ContestWinner[]
    },
    orderPlaces: function (): Array<ContestWinner[]> {
      return [
        this.firstPlaces as ContestWinner[],
        this.secondPlaces as ContestWinner[],
        this.thirdPlaces as ContestWinner[],
        this.optionalAwardPlaces as ContestWinner[],
        this.nextPlaces as ContestWinner[],
      ]
    },
  },
})
